'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseResource = require('../resources/base-resource');

var _baseResource2 = _interopRequireDefault(_baseResource);

var _duration = require('../helpers/duration');

var _tracking = require('../helpers/tracking');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NonLinear = function (_React$Component) {
  _inherits(NonLinear, _React$Component);

  function NonLinear(props) {
    _classCallCheck(this, NonLinear);

    var _this = _possibleConstructorReturn(this, (NonLinear.__proto__ || Object.getPrototypeOf(NonLinear)).call(this, props));

    _this.durationMillis = (0, _duration.getVastDurationInMillis)(_this.props.duration);
    _this.startTrackingArr = (0, _tracking.getTracking)('start', _this.props.tracking);
    _this.completeTrackingArr = (0, _tracking.getTracking)('complete', _this.props.tracking);
    return _this;
  }

  _createClass(NonLinear, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.onStartedTracking();
      setTimeout(function (e) {
        _this2.onCompletedTracking();
        _this2.props.onEnded(e);
      }, this.durationMillis);
    }
  }, {
    key: 'onStartedTracking',
    value: function onStartedTracking() {
      this.startTrackingArr.forEach(function (src) {
        _axios2.default.get(src);
      });
    }
  }, {
    key: 'onCompletedTracking',
    value: function onCompletedTracking() {
      this.completeTrackingArr.forEach(function (src) {
        _axios2.default.get(src);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_baseResource2.default, {
        baseResource: this.props.nonLinear,
        height: this.props.height,
        width: this.props.width
      });
    }
  }]);

  return NonLinear;
}(_react2.default.Component);

NonLinear.propTypes = {
  tracking: _react2.default.PropTypes.array,
  onEnded: _react2.default.PropTypes.func,
  nonLinear: _react2.default.PropTypes.object,
  height: _react2.default.PropTypes.number,
  width: _react2.default.PropTypes.number,
  duration: _react2.default.PropTypes.string
};

exports.default = NonLinear;
//# sourceMappingURL=non-linear.js.map


// WEBPACK FOOTER //
// ./src/in-line/non-linear.js